<div class="flex h-full w-full">
  <!-- Sidebar -->
  @if (businessUnitsList.error()) {
  <div class="w-80 p-4" role="alert">
    <p>{{ 'membership-list-load-failed' | transloco }}</p>
    <button type="button" (click)="businessUnitsList.reload()">{{ 'membership-retry' | transloco }}</button>
  </div>
  } @else if (businessUnitsList.value(); as units) {
  <dtis-admin-business-unit-sidebar
    [businessUnits]="units"
    [selectedUnit]="selectedUnit()"
    (selectUnit)="selectBusinessUnit($event)"
    (createNew)="openCreateBusinessUnitDialog()"
  />
  } @else if (businessUnitsList.isLoading()) {
  <div class="flex w-80 items-center justify-center border-r border-outlineVariant">
    <mat-progress-spinner mode="indeterminate" diameter="40" />
  </div>
  }

  <!-- Detail View -->
  <div class="flex-1">
    <dtis-admin-business-unit-detail-view
      [businessUnitId]="selectedUnit()?.identifier"
      (update)="businessUnitsList.reload()"
      (leave)="onLeaveBusinessUnit()"
      (delete)="deleteBusinessUnit($event)"
    />
  </div>
</div>
